import { connect } from "react-redux";
import Router from "next/router";
import PropTypes from "prop-types";
import Link from "next/link";

import { addRemoveUrlResealed } from "@lib/filterUtil";
import Modal from "@components/Modal";
import { removeModal } from "@store/app/actions";
import ActiveFilters from "./ActiveFilters";
import FilterGroup from "./FilterGroup";
import ResealedNav from "./ResealedNav";
import {
  setGTMProductsFilterApply,
  setGTMProductsFilterRemove,
} from "@lib/GTMHelper";

const ResealedFilters = ({
  name,
  activeFilters,
  filters,
  query,
  totalProducts,
  extractedFiltersParams,
  removeModal,
  navigationCategories,
}) => {
  const hasActiveFilters = Boolean(activeFilters.length);

  const handleFilterMobileApply = (parentSlug, filter, generalSlugs) => {
    const filQuery = { ...extractedFiltersParams.filters };
    // we remove existing values for this filter group as we always send all active values in the callback
    parentSlug
      ? delete filQuery[parentSlug]
      : generalSlugs.forEach((slug) => delete filQuery[slug]);

    const url = addRemoveUrlResealed(
      "add",
      filter.filters.map((filterOption) => ({
        filter: filterOption.attributeSlug || parentSlug,
        filterValue: filterOption.slug,
        replaceValue: false,
      })),
      filQuery,
      "list",
      query || {}
    );

    //GTM tracking start
    const operation =
      filter.filters.length === 0 ||
      filter.filters.every((filter) => filter.isActive)
        ? "remove"
        : "add";

    if (operation === "add") {
      setGTMProductsFilterApply({
        addedFilters: filter,
        activeFilters,
      });
    } else {
      setGTMProductsFilterRemove({
        removedFilters: filter,
        activeFilters,
      });
    }
    // GTM tracking end

    removeModal();
    Router.push(url);
  };

  return (
    <>
      <div className="hidden lg:block lg:w-1/5 lg:mt-3 sm:pr-6">
        {navigationCategories && (
          <div className="mb-[60px]">
            <ResealedNav categories={navigationCategories} />
          </div>
        )}

        <div className="Filters" id="catalog-filters-container">
          <ul data-test="FILTERS_LIST">
            {filters.map((filter, index) => (
              <FilterGroup
                filter={filter}
                isModal={false}
                key={index}
                isLast={index == filters.length - 1}
                onFilterMobileApply={handleFilterMobileApply}
                activeFilters={activeFilters}
              />
            ))}
          </ul>
        </div>
      </div>

      <Modal
        id="resealed"
        header={name}
        hasStickyHeader={true}
        hasStickyFooter={true}
        hasRadius={false}
      >
        {navigationCategories && (
          <div className="mb-[60px]">
            <ResealedNav categories={navigationCategories} />
          </div>
        )}
      </Modal>

      <Modal
        id="filters"
        header="Filtreaza"
        hasStickyHeader={true}
        hasStickyFooter={true}
        hasRadius={false}
        footer={
          <div>
            <div className="flex space-x-2">
              <button
                className="py-2 px-5 text-14px border-2 border-transparent bg-filterYellow w-full rounded-bl-lg rounded-tr-lg"
                onClick={() => removeModal()}
              >
                Vezi {totalProducts}{" "}
                {totalProducts !== 1 ? "produse" : "produs"}
              </button>

              {hasActiveFilters && (
                <Link href={activeFilters.find((el) => el.removeAll).removeUrl}>
                  <a
                    className="py-2 px-5 text-center text-14px border-2 border-filterYellow w-full rounded-bl-lg rounded-tr-lg"
                    onClick={() => removeModal()}
                  >
                    Sterge tot
                  </a>
                </Link>
              )}
            </div>
          </div>
        }
      >
        {hasActiveFilters && (
          <div className="Filters-group Filters-group--remove js-active-filters mb-4 ">
            <ActiveFilters activeFilters={activeFilters} />
          </div>
        )}

        <div className="md:mt-6">
          <div className="Filters" id="catalog-filters-container">
            <ul>
              {filters.map((filter, index) => (
                <FilterGroup
                  filter={filter}
                  isModal={true}
                  onFilterMobileApply={handleFilterMobileApply}
                  isLast={index == filters.length - 1}
                  key={index}
                  activeFilters={activeFilters}
                />
              ))}
            </ul>
          </div>
        </div>
      </Modal>
    </>
  );
};

ResealedFilters.propTypes = {
  filters: PropTypes.array.isRequired,
  extractedFiltersParams: PropTypes.object.isRequired,
};

export default connect(null, {
  removeModal,
})(ResealedFilters);
